export enum PosthogFeatureFlags {
  TWO_MONTHS_PROP = '2-month-purchase-date-prop-mar-26',
  QUOTE_PAGE_EXPERIMENT = 'quote-page-experiment-apr-26',
  // This is the feature flag for the QR code registration source that will be used for the new QR code registration source test.
  LANDING_PAGE = 'landing-page-may-2026',
  LANDING_PAGE_KHAID = 'landing-page-oct-2026-khaid',
  LANDING_PAGE_WHIRL = 'landing-page-nov-2026-whirl',
  PERSONALISED_QUOTE_WHIRL = 'personalised-quote-oct-2026-whirl',
  PERSONALISED_QUOTE_KHAID = 'personalised-quote-oct-2026-khaid',
  PERSONALISED_QUOTE_MYTAG = 'personalised-quote-oct-2026-mytag',
  PERSONALISED_QUOTE_AMANA = 'personalised-quote-oct-2026-amana',
  PERSONALISED_QUOTE_JNAIR = 'personalised-quote-oct-2026-jnair',
  PERSONALISED_QUOTE_ELUX = 'personalised-quote-oct-2026-elux',
  PERSONALISED_QUOTE_FRIGI = 'personalised-quote-oct-2026-frigi',
  PERSONALISED_QUOTE_HISEN = 'personalised-quote-oct-2026-hisen',

  // The quote page A/B experiment runs as one flag shared by all Whirlpool family brands.
  QUOTE_PAGE_V2_WHP = 'quote-page-v2-oct-2026-whirlpool-brands',
  CALL_US_LANDING_PAGE = 'call-us-landing-oct-2026',
  GIFT_MESSAGE = 'gift-message-aug-nov-2026',
  CALL_US_HEADER = 'call-us-header-sep-2026',
  CALL_US_MODAL = 'call-us-modal-oct-2026',
  CHECKOUT_PAGE = 'checkout-page-sep-2026',
  MAINTENANCE_MODE = 'maintenance-mode',
}

export enum CheckoutPageVariant {
  CONTROL = 'control',
  TEST = 'test',
}

const checkoutPageVariants: string[] = Object.values(CheckoutPageVariant);

export const isCheckoutPageVariant = (value: unknown): value is CheckoutPageVariant =>
  typeof value === 'string' && checkoutPageVariants.includes(value);

export enum CallUsLandingPageVariant {
  CONTROL = 'control',
  CALLUS = 'call_us_variant',
}
const callUsLandingPageVariants: string[] = Object.values(CallUsLandingPageVariant);

export const isCallUsLandingPageVariant = (value: unknown): value is CallUsLandingPageVariant =>
  typeof value === 'string' && callUsLandingPageVariants.includes(value);

const isPathList = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((path) => typeof path === 'string');

export const isCallUsHeaderPage = (payload: unknown, pathname: string, brand?: string): boolean => {
  if (typeof payload !== 'object' || payload === null || Array.isArray(payload)) return true;

  const pagesByBrand = payload as Record<string, unknown>;
  const brandPages = brand ? pagesByBrand[brand] : undefined;
  const pages = isPathList(brandPages) ? brandPages : pagesByBrand.default;

  return isPathList(pages) ? pages.includes(pathname) : true;
};

export enum QuotePageVariant {
  CONTROL = 'control',
  RADIO = 'variant_2_radio',
}

const quotePageVariants: string[] = Object.values(QuotePageVariant);

export const isQuotePageVariant = (value: unknown): value is QuotePageVariant =>
  typeof value === 'string' && quotePageVariants.includes(value);

const quotePageBrands = ['WHIRL', 'KHAID', 'MYTAG', 'JNAIR', 'AMANA'];

export const getQuotePageFlag = (brand?: string): PosthogFeatureFlags | undefined =>
  brand && quotePageBrands.includes(brand) ? PosthogFeatureFlags.QUOTE_PAGE_V2_WHP : undefined;

export enum PersonalisedQuoteVariant {
  CONTROL = 'control',
  PERSONALISED = 'personalised',
}

const personalisedQuoteVariants: string[] = Object.values(PersonalisedQuoteVariant);

export const isPersonalisedQuoteVariant = (value: unknown): value is PersonalisedQuoteVariant =>
  typeof value === 'string' && personalisedQuoteVariants.includes(value);

const personalisedQuoteFlagsByBrand: Record<string, PosthogFeatureFlags> = {
  WHIRL: PosthogFeatureFlags.PERSONALISED_QUOTE_WHIRL,
  KHAID: PosthogFeatureFlags.PERSONALISED_QUOTE_KHAID,
  MYTAG: PosthogFeatureFlags.PERSONALISED_QUOTE_MYTAG,
  AMANA: PosthogFeatureFlags.PERSONALISED_QUOTE_AMANA,
  JNAIR: PosthogFeatureFlags.PERSONALISED_QUOTE_JNAIR,
  ELUX: PosthogFeatureFlags.PERSONALISED_QUOTE_ELUX,
  FRIGI: PosthogFeatureFlags.PERSONALISED_QUOTE_FRIGI,
  HISEN: PosthogFeatureFlags.PERSONALISED_QUOTE_HISEN,
};

export const getPersonalisedQuoteFlag = (brand?: string): PosthogFeatureFlags | undefined =>
  brand ? personalisedQuoteFlagsByBrand[brand] : undefined;
